module.exports = __webpack_public_path__ + "static/bootstrap-button-large-a929124308981f4c93ae0dcc61aec8c9.png";